import { t$2 } from '@/js/global/global'
import { shouldAnimate } from '@/js/global/helpers'
import { register } from '@/js/global/shopify-theme-sections'
import { animateImageFlipAndSlider } from '@/js/global/animations'
import { navigationDots } from '@/js/modules/carousel'

const selectorsImageFlipAndSliders = {
  slider: "[data-slider]",
  slide: "[data-slide]",
};

register("image-fas", {
  onLoad() {
    const imageFasContainers = t$2(selectorsImageFlipAndSliders.slider, this.container);

    function initSwiper(swiperContainers) {
      // Collect swipers in an array
      let swiperInstances = [];

      import('@/js/vendor/swiper-chunk.js').then(_ref => {
        let {
          Swiper,
          Navigation
        } = _ref;

        swiperContainers.forEach(imageFasContainer => {
          // Init each swiper instance if not already initialized
          if (!imageFasContainer.classList.contains('swiper-initialized')) {
            const swiper = new Swiper(imageFasContainer, {
              modules: [
                Navigation
              ],
              grabCursor: true,
              loop: true,
              autoplay: false
            });

            const dotNavigation = navigationDots(imageFasContainer, {
              onSelect: dotIndex => {
                swiper.slideToLoop(dotIndex);
              }
            });

            swiper.on("slideChange", () => {
              const index = swiper.realIndex;
              dotNavigation.update(index);
            });

            swiperInstances.push(swiper);
          }
        })

        // Destroy each swiper instance if window is desktop size
        if (window.innerWidth >= 960) {
          swiperInstances.forEach(swiperInstance => swiperInstance.destroy());
        }
      });
    }

    if (window.innerWidth <= 959) {
      initSwiper(imageFasContainers);
    }

    window.addEventListener('resize', () => {
      setTimeout(function() {
        if (window.innerWidth < 960) {
          initSwiper(imageFasContainers);
        }
      }, 200);
    });

    if (shouldAnimate(this.container)) {
      this.animateImageFlipAndSlider = animateImageFlipAndSlider(this.container);
    }
  },

  onUnload() {
    var _this$animateImageFlipAndSlider;
    (_this$animateImageFlipAndSlider = this.animateImageFlipAndSlider) === null || _this$animateImageFlipAndSlider === void 0 ? void 0 : _this$animateImageFlipAndSlider.destroy();
  }
});